import React from "react";
import { useAuth } from "../lib/auth";
import { Navigate, useLocation } from "react-router-dom";

export default function Protected({ children, adminOnly = false, artistOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container-x py-20 text-center text-black/50">Loading...</div>;
  if (!user) return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (artistOnly && user.account_type !== "artist") return <Navigate to="/dashboard" replace />;
  return children;
}
